export default __webpack_public_path__ + "static/media/campus-ornament-2.37022f0f.png";